import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAttendance,
  deleteAttendance,
} from "../redux/actions/attendanceActions";
import {
  FiSearch,
  FiDownload,
  FiTrash2,
  FiMapPin,
  FiImage,
  FiX,
  FiCalendar,
  FiUser,
  FiPhone,
  FiClock,
  FiFilter,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import Papa from "papaparse";
const Attendance = () => {
  const dispatch = useDispatch();

  const { attendance, loading, error, pagination } = useSelector(
    (state) => state.attendance,
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [photoModalOpen, setPhotoModalOpen] = useState(false);
  const [photoUrl, setPhotoUrl] = useState("");
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [mapAddress, setMapAddress] = useState("Loading...");
  const [mapLoading, setMapLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const itemsPerPage = 10;
  const GOOGLE_MAPS_KEY = process.env.REACT_APP_MAP_API_KEY;

const normalizeDate = (d) => d?.split("T")[0];

  // Fetch Attendance
  useEffect(() => {
    dispatch(
      fetchAttendance({
        page: currentPage,
        limit: itemsPerPage,
       
      }),
    );
  }, [dispatch, currentPage]);

  const [allAttendance, setAllAttendance] = useState([]); //my local master copy that remains untouched
  const [tableContent, setTableContent] = useState([]); //my filter copy that shouvik da suggested

  useEffect(() => {
    if (attendance && attendance.length) {
      setAllAttendance(attendance);
      setTableContent(attendance);
    }
  }, [attendance]);

  //filter for name, designation, dates
  useEffect(() => {
    if (!allAttendance || !allAttendance.length) return;

    const lowerSearch = searchTerm.trim().toLowerCase();

    const filtered = allAttendance.filter((att) => {
      // Search filter
      const matchesSearch =
        !lowerSearch ||
        att.employee_name?.toLowerCase().includes(lowerSearch) ||
        att.employee_phone?.toLowerCase().includes(lowerSearch);

      // Date filter
      const attDate = normalizeDate(att.date);
      const from = fromDate || null;
      const to = toDate || null;

      const matchesFromDate = !from || attDate >= from;
      const matchesToDate = !to || attDate <= to;



      return (
        matchesSearch && matchesFromDate && matchesToDate
      );
    });

    setTableContent(filtered);
  }, [searchTerm, fromDate, toDate, allAttendance]);


  const openPhotoModal = (url) => {
    setPhotoUrl(url);
    setPhotoModalOpen(true);
  };

  const closePhotoModal = () => {
    setPhotoModalOpen(false);
    setPhotoUrl("");
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setConfirmDeleteOpen(true);
  };

  const confirmDelete = () => {
    dispatch(deleteAttendance(deleteId));
    setConfirmDeleteOpen(false);
    setDeleteId(null);
  };

  const openMapModal = async (lat, lng) => {
    setMapModalOpen(true);
    setMapLoading(true);
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_KEY}`,
      );
      const data = await response.json();
      if (data.status === "OK") {
        setMapAddress(data.results[0]?.formatted_address || "No address found");
      } else {
        setMapAddress("Unable to fetch address");
      }
    } catch (err) {
      setMapAddress("Error fetching address");
    } finally {
      setMapLoading(false);
    }
  };

  const closeMapModal = () => {
    setMapModalOpen(false);
    setMapAddress("");
  };

  const handleDownloadCSV = () => {
    const csvRows = [
      [
        "Date",
        "Employee Name",
        "Phone",
        "Check-In Time",
        "Check-In Address",
        "Check-Out Time",
        "Check-Out Address",
        "Remarks",
      ],
    ];

    attendance.forEach((att) => {
      csvRows.push([
        att.date || "",
        att.employee_name || "",
        att.employee_phone || "",
        att.check_in || "",
        att.check_in_latitude && att.check_in_longitude
          ? "Location Available"
          : "",
        att.check_out || "",
        att.check_out_latitude && att.check_out_longitude
          ? "Location Available"
          : "",
        att.remarks || "",
      ]);
    });

    const csv = Papa.unparse(csvRows, { skipEmptyLines: true });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `Attendance_Report_${new Date().toISOString().split("T")[0]}.csv`,
    );
    link.click();
  };

  const clearFilters = () => {
    setFromDate("");
    setToDate("");
    setSearchTerm("");
    setCurrentPage(1);
  };

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("T")[0].split("-");
  return `${day}/${month}/${year}`; // DD/MM/YYYY
};
  // const formatTime = (timeStr) => timeStr ? new Date(timeStr).toLocaleTimeString("en-IN", {
  //   hour: '2-digit',
  //   minute: '2-digit'
  // }) : "-";
  const formatTime = (timeStr, dateStr) => {
    if (!timeStr) return "-";
    const dateTime = new Date(`${dateStr.split("T")[0]}T${timeStr}`);
    return isNaN(dateTime)
      ? "-"
      : dateTime.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            Loading Attendance Records...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Attendance Records
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Track and manage employee attendance
          </p>
        </div>
        <div className="flex items-center gap-3 mt-4 lg:mt-0">
          <button
            onClick={handleDownloadCSV}
            className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-colors"
          >
            <FiDownload className="text-lg" />
            Export CSV
          </button>
        </div>
      </div>

      {/* Search and Filter Bar */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 p-6 mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4">
          {/* Search Input */}
          <div className="flex-1 relative">
            <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
            <input
              type="text"
              placeholder="Search by name, phone, or designation..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-gray-50 dark:bg-gray-700 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white dark:focus:bg-gray-600 transition text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
            />
          </div>

       

        </div>

       
      </div>

      {/* Results Count */}
      <div className="flex items-center justify-between mb-4">
        <p className="text-gray-600 dark:text-gray-400">
          Showing {tableContent.length} of {pagination?.totalRecords || 0}{" "}
          records
        </p>
        <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
          <span>
            Page {currentPage} of {pagination?.totalPages || 1}
          </span>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-700/50">
              <tr>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiUser />
                    Employee
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiCalendar />
                    Date
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiClock />
                    Check-In
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  <div className="flex items-center gap-2">
                    <FiClock />
                    Check-Out
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Location
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Photo
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Remarks
                </th>
                <th className="py-4 px-6 text-left text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {error ? (
                <tr>
                  <td colSpan={8} className="py-8 px-6 text-center">
                    <div className="text-red-500 dark:text-red-400">
                      {error}
                    </div>
                  </td>
                </tr>
              ) : attendance.length === 0 ? (
                <tr>
                  <td colSpan={8} className="py-12 px-6 text-center">
                    <FiUser className="text-4xl text-gray-400 mx-auto mb-4" />
                    <p className="text-gray-500 dark:text-gray-400 text-lg mb-2">
                      No attendance records found
                    </p>
                    <p className="text-gray-400 dark:text-gray-500 text-sm">
                      Try adjusting your search or filters
                    </p>
                  </td>
                </tr>
              ) : (
                tableContent.map((att) => (
                  <tr
                    key={att.id}
                    className="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors"
                  >
                    {/* Employee Info */}
                    <td className="py-4 px-6">
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">
                          {att.employee_name}
                        </p>
                       
                        <p className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1">
                          <FiPhone className="text-xs" />
                          {att.employee_phone}
                        </p>
                      </div>
                    </td>

                    {/* Date */}
                    <td className="py-4 px-6 text-gray-600 dark:text-gray-400 text-sm">
                      {formatDate(att.date)}
                    </td>

                    {/* Check-In */}
                    <td className="py-4 px-6">
                      <div className="text-sm">
                        <p className="text-gray-900 dark:text-white font-medium">
                          {/* {formatTime(att.check_in)} */}
                          {formatTime(att.check_in, att.date)}
                        </p>
                        {att.check_in_latitude && att.check_in_longitude && (
                          <button
                            onClick={() =>
                              openMapModal(
                                att.check_in_latitude,
                                att.check_in_longitude,
                              )
                            }
                            className="flex items-center gap-1 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 text-xs mt-1"
                          >
                            <FiMapPin className="text-xs" />
                            View Location
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Check-Out */}
                    <td className="py-4 px-6">
                      <div className="text-sm">
                        <p className="text-gray-900 dark:text-white font-medium">
                          {/* {formatTime(att.check_out)} */}
                          {formatTime(att.check_out, att.date)}
                        </p>
                        {att.check_out_latitude && att.check_out_longitude && (
                          <button
                            onClick={() =>
                              openMapModal(
                                att.check_out_latitude,
                                att.check_out_longitude,
                              )
                            }
                            className="flex items-center gap-1 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 text-xs mt-1"
                          >
                            <FiMapPin className="text-xs" />
                            View Location
                          </button>
                        )}
                      </div>
                    </td>

                    {/* Location Status */}
                    <td className="py-4 px-6 text-sm text-gray-600 dark:text-gray-400">
                      <div className="space-y-1">
                        {att.check_in_latitude && (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300">
                            Check-In
                          </span>
                        )}
                        {att.check_out_latitude && (
                          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 ml-1">
                            Check-Out
                          </span>
                        )}
                      </div>
                    </td>

                    {/* Photo */}
                    <td className="py-4 px-6">
                      <div className="flex gap-2">
                        {att.check_in_photo && (
                          <button
                            onClick={() => openPhotoModal(att.check_in_photo)}
                            className="flex items-center gap-1 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 text-sm"
                          >
                            <FiImage className="text-sm" />
                            In
                          </button>
                        )}
                        {att.check_out_photo && (
                          <button
                            onClick={() => openPhotoModal(att.check_out_photo)}
                            className="flex items-center gap-1 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 text-sm"
                          >
                            <FiImage className="text-sm" />
                            Out
                          </button>
                        )}
                        {!att.check_in_photo && !att.check_out_photo && (
                          <span className="text-gray-400 text-sm">-</span>
                        )}
                      </div>
                    </td>

                    {/* Remarks */}
                    <td className="py-4 px-6 text-sm text-gray-600 dark:text-gray-400 max-w-xs">
                      {att.remarks || "-"}
                    </td>

                    {/* Actions */}
                    <td className="py-4 px-6">
                      <button
                        onClick={() => handleDeleteClick(att.id)}
                        className="flex items-center gap-1 text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300 p-2 rounded-lg transition-colors"
                        title="Delete Record"
                      >
                        <FiTrash2 className="text-sm" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      {pagination && pagination.totalPages > 1 && (
        <div className="flex items-center justify-between mt-6">
          <button
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="flex items-center gap-2 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 px-4 py-2 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <FiChevronLeft />
            Previous
          </button>

          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <span>
              Page {currentPage} of {pagination.totalPages}
            </span>
          </div>

          <button
            onClick={() =>
              setCurrentPage((p) => Math.min(pagination.totalPages, p + 1))
            }
            disabled={currentPage === pagination.totalPages}
            className="flex items-center gap-2 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 px-4 py-2 rounded-xl border border-gray-200 dark:border-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
            <FiChevronRight />
          </button>
        </div>
      )}

      {/* Photo Modal */}
      {photoModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Attendance Photo
              </h3>
              <button
                onClick={closePhotoModal}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              >
                <FiX className="text-xl" />
              </button>
            </div>
            <div className="p-4">
              <img
                src={photoUrl}
                alt="Attendance"
                className="max-w-full max-h-[70vh] object-contain rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      {/* Map Modal */}
      {mapModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Location Address
              </h3>
              <button
                onClick={closeMapModal}
                className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              >
                <FiX className="text-xl" />
              </button>
            </div>
            <div className="p-4">
              {mapLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  <span className="ml-2 text-gray-600 dark:text-gray-400">
                    Fetching address...
                  </span>
                </div>
              ) : (
                <p className="text-gray-700 dark:text-gray-300">{mapAddress}</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {confirmDeleteOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 dark:bg-red-900/30 rounded-full">
                <FiTrash2 className="text-red-600 dark:text-red-400 text-xl" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white text-center mb-2">
                Delete Attendance Record
              </h3>
              <p className="text-gray-600 dark:text-gray-400 text-center mb-6">
                Are you sure you want to delete this attendance record? This
                action cannot be undone.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setConfirmDeleteOpen(false)}
                  className="flex-1 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 py-2 px-4 rounded-lg transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition-colors"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Attendance;
